import React from 'react'
import { Box, ChakraProvider, extendTheme } from '@chakra-ui/react'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import router from './router'

// import { AOSInit } from './lib/aos'

const client = new QueryClient()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

const theme = extendTheme({
  fonts: {
    body: 'Spoqa Han Sans Neo, sans-serif',
    heading: 'Spoqa Han Sans Neo, sans-serif',
  },
  colors: {
    primary: {
      50: '#e6f0ff',
      100: '#b3d1ff',
      200: '#80b2ff',
      300: '#4d94ff',
      400: '#1a75ff',
      500: '#0046ff', // 기본 색상
      600: '#0039cc',
      700: '#002d99',
      800: '#002066',
      900: '#001433',
    },
    secondary: {
      50: '#e5eaff',
      100: '#b3b8ff',
      200: '#8087ff',
      300: '#4d56ff',
      400: '#1a25ff',
      500: '#00236e', // 기본 색상
      600: '#001a55',
      700: '#00113c',
      800: '#000822',
      900: '#00000f',
    },
  },
})

root.render(
  <ChakraProvider theme={theme}>
    <QueryClientProvider client={client}>
      {/* <AOSInit /> */}
      <Box>
        <RouterProvider router={router} />
      </Box>
    </QueryClientProvider>
  </ChakraProvider>
)
